module.exports = "<div class=\"tingle-modal tingle-modal-dark tingle-modal--visible tingle-modal--overflow\" id=\"student-plan-application-modal\">\n  <div class=\"tingle-modal-box\">\n    <div class=\"tingle-modal-box__content\">\n      <button class=\"tingle-modal-close-button\" ng-click=\"$ctrl.onCancel()\"></button>\n      <span ng-bind-html=\"$ctrl.content\"></span>    </div>\n  </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/student/nosub/nosub.html
// module id = 332
// module chunks = 0